webpackJsonp([124123295438624],{

/***/ 1562:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"StockTransferNoteInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"note","type":{"kind":"SCALAR","name":"String","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-stock-transfer-note-input-9f3ad24b0d6062ee068c.js